const CustomSpinner = () => {
    return (
        <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-slate-50/80 backdrop-blur-sm dark:bg-slate-950/80">
            <div className="h-12 w-12 animate-spin rounded-full border-4 border-sky-400/30 border-t-sky-400" />
            <span className="mt-4 text-lg font-medium text-slate-900 dark:text-slate-100">Cargando...</span>
        </div>
    );
}

export default CustomSpinner;